import {memo} from "react";
import {Link} from "react-router-dom";

import {ChevronRightIcon} from "../../react/components/Icons";
import {HStack} from "../ui/hstack";
import {Pressable} from "../ui/pressable";
import {Text} from "../ui/text";

import type {BreadcrumbItem} from "./types";

interface Props {
    items: BreadcrumbItem[];
    className?: string;
}

const Breadcrumb: React.FC<Props> = ({items, className}) => {
    const itemNodes = items.map((item, index) => (
        <HStack key={index} className="items-center">
            {item.path ? (
                <Pressable aria-label="Breadcrumb" className="hover:bg-blueGray-100">
                    <Link to={item.path}>
                        <Text color="blueGray.400" variant="xs">
                            {item.title}
                        </Text>
                    </Link>
                </Pressable>
            ) : item.onClick ? (
                <Pressable
                    aria-label="Breadcrumb"
                    className="hover:bg-blueGray-100"
                    onPress={item.onClick}
                >
                    <Text color="blueGray.400" variant="xs">
                        {item.title}
                    </Text>
                </Pressable>
            ) : (
                <Text aria-label="Breadcrumb" color="blueGray.400" variant="xs">
                    {item.title}
                </Text>
            )}
            {index < items.length - 1 && <ChevronRightIcon color="blueGray.400" size="sm" />}
        </HStack>
    ));

    return (
        <HStack className={className} space="xs">
            {itemNodes}
        </HStack>
    );
};

export default memo(Breadcrumb);
